import { useQueryParams } from 'use-query-params'

import { DashArrayParam } from '../../../../utils/useQueryParams'
import { RulesFiltersEnum } from '../RulesFilters'

import styles from './rules-filters-options.module.scss'

interface IConversationsFiltersOptionProps {
    category: RulesFiltersEnum
    filtersOptions: {
        intents: string[]
        actions: string[]
    }
}

function RulesFiltersOptions(props: IConversationsFiltersOptionProps) {
    const { category, filtersOptions } = props

    const [query, setQuery] = useQueryParams({
        [RulesFiltersEnum.INTENTS]: DashArrayParam,
        [RulesFiltersEnum.ACTIONS]: DashArrayParam,
    })

    const handleOptionChange = (selectedOptions: string[], option: string) => {
        const clonedSelectedOptions = structuredClone(selectedOptions) || []

        if (clonedSelectedOptions.includes(option)) {
            const index = clonedSelectedOptions.indexOf(option)
            clonedSelectedOptions.splice(index, 1)
            setQuery({
                [category]: clonedSelectedOptions.length
                    ? clonedSelectedOptions
                    : null,
            })
            return
        }

        clonedSelectedOptions?.push(option)

        setQuery({ [category]: clonedSelectedOptions })
    }

    const selectedOptions = query[category] as string[]

    return (
        <div className={styles.rulesFiltersOptions}>
            {filtersOptions[category].map((option) => (
                <label
                    key={option}
                    className={styles.rulesFiltersOptions__label}
                >
                    <input
                        type="checkbox"
                        checked={selectedOptions?.includes(option)}
                        onChange={() =>
                            handleOptionChange(selectedOptions, option)
                        }
                    />
                    {option}
                </label>
            ))}
        </div>
    )
}

export default RulesFiltersOptions
